export default __webpack_public_path__ + "static/2-2-resource-f67d7952be0b4a911d940cde91c281e3.gif";